module.exports = [
  'rent',
  'accounting',
  'utilities',
  'supplies',
  'equipment',
  'maintenance',
  'marketing',
  'insurance',
  'wages',
  'taxes',
  'consulting',
  'cleaning',
  'trainings',
  'team',
  'other'
]
